<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12 pt-5>
        <v-card>
          <v-layout justify-start wrap pt-6>
            <v-layout justify-center wrap>
              <v-flex xs3 sm3 md3 pl-5 text-center>
                <v-icon color="#9B8DFD">mdi-account</v-icon>
              </v-flex>
              <v-flex xs9 sm9 md9 text-left>
                <span
                  style="
                    font-family: nunitosansbold;
                    font-size: 20px;
                    color: #000000;
                  "
                  >Add Admin</span
                >
              </v-flex>
            </v-layout>
            <v-flex xs6 sm6 md9>
              <router-link :to="'/adminList'" style="text-decoration: none">
                <span
                  style="
                    color: #797979;
                    font-family: nunitosanssemibold;
                    font-size: 18px;
                  "
                  >View Admin</span
                >
              </router-link>
            </v-flex></v-layout
          >
          <v-card-text>
            <v-layout justify-center wrap>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="admin.name"
                  label="Name"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="admin.phone"
                  label="Phone"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-text-field
                  v-model="admin.email"
                  label="Email"
                  :rules="emailRules"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  v-model="school"
                  dense
                  style="font-family: nunitosanssemibold"
                  outlined
                  label="School"
                  :items="schoolArray"
                  item-text="name"
                  item-value="_id"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-select
                  dense
                  label="Gender"
                  outlined
                  style="font-family: nunitosanssemibold"
                  v-model="admin.gender"
                  :items="genders"
                  hide-details
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md6 pa-2>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="admin.dob"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="admin.dob"
                      label="DOB"
                      readonly
                      outlined
                      dense
                      class="text"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="admin.dob" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu.save(admin.dob)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm12 md12 pa-2>
                <v-textarea
                  v-model="admin.address"
                  dense
                  style="font-family: nunitosansregular"
                  outlined
                  placeholder="Address"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout justify-center wrap>
              <v-flex xs12 sm6 md4 py-8>
                <v-btn
                  @click="validateInput"
                  dark
                  block
                  height="50px"
                  style="font-family: nunitosanssemibold"
                  color="#9B8DFD"
                  >ADD Admin</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      hover: false,
      appLoading: false,
      showsnackbar: false,
      ServerError: false,
      msg: "",
      menu: false,
      timeout: 5000,
      showPreview: false,
      file: null,
      imagePreview: "",
      id: "",
      school: "",
      genders: ["Male", "Female", "Other"],
      admin: {
        name: null,
        phone: null,
        email: null,
        gender: null,
        dob: null,
        address: null,
      },
      schoolArray: [],
      page: 1,
      user: [],
      group: [],
      emailRules: [
        (v) => !!v || "Email is Required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  watch: {
    school() {
      this.getSchool();
    },
  },
  mounted() {
    this.getSchool();
  },
  methods: {
    validateInput() {
      if (!this.admin.name) {
        this.msg = "Please Provide Name";
        this.showsnackbar = true;
        return;
      } else if (!this.admin.address) {
        this.msg = "Please Provide Address";
        this.showsnackbar = true;
        return;
      } else if (!this.admin.email) {
        this.msg = "Please Provide Email";
        this.showsnackbar = true;
        return;
      } else {
        this.addAdmin();
      }
    },
    getSchool() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/school/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.schoolArray = response.data.data;
            this.pages = response.data.pages;
            this.totalData = response.data.count;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addAdmin() {
      this.appLoading = true;
      this.admin.school = this.school;
      axios({
        method: "POST",
        url: "/school/admin/add",
        data: this.admin,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Admin Added Successully";
            this.showsnackbar = true;
            this.$router.push({ path: "/adminList" });
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.dottedline {
  border: none;
  /* border-top: 1px dashed rgb(208, 208, 208); */
  color: #8f8f8f;
  /* text-align: center; */
  background-color: #8f8f8f;
  height: 1px;
  width: 100%;
}
</style>